import React from "react";
import CountUp from "./CountUp";

const DetailsBar =()=>{

    return(
        <div className="flex justify-center font-guton">
            <div className="flex flex-col md:flex-row  justify-between text-white w-70 max-w-[1440px]">
                <div className="flex-col pt-20 pb-5 md:py-10 xl:py-20">
                    <p className="text-17 xl:text-30 font-medium text-center">Graduate in</p>
                    <p className="text-42 xl:text-71 text-center font-bold leading-42 xl:leading-60 tracking-[-2px]"><CountUp from={0} to={3} direction="up" duration={1} /> Years</p>
                </div>
                <div className="flex-col pt-5 pb-5 md:py-10 xl:py-20">
                    <p className="text-17 xl:text-30 font-medium text-center">Average Tuition Fees</p>
                    <p className="text-42 xl:text-71 font-bold text-center leading-60 tracking-[-2px]">€<CountUp from={0} to={3000} direction="up" duration={1} /></p>
                </div>
                <div className="flex-col pt-5 pb-20 md:py-10 xl:py-20">
                    <p className="text-17 xl:text-30 font-medium text-center">Universities We Cover</p>
                    <p className="text-42 xl:text-71 font-bold text-center leading-60 tracking-[-2px]"><CountUp from={0} to={20} direction="up" duration={1} />+</p>
                </div>
            </div>
        </div>
    )
}

export default DetailsBar;